import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailStoriesProps as Props } from './types';
import { getCompanyPosts } from '../../../services/companies'; 

export const Component: FunctionComponent<Props> = (props) => {
  const [postIds, setPostIds] = useState<number[]>([]);

  useEffect(() => {
    let aborted = false;

    const fetchPosts = async () => {
      try {
        const response = await getCompanyPosts(props.company.id);
        if (!aborted) {
          setPostIds(response.postIds || []);
          props.setIdCount('postIds', (response.postIds || []).length);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchPosts();
    return () => {
      aborted = true;
    };
  }, [props.company.id, props.setIdCount]);

  return (
    <Presentation
      company={props.company}
      postIds={postIds}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};